module.exports = __webpack_public_path__ + "static/media/durotype-flexosoft-regular.203ad68d.otf";